<template>
  <div>
    <div class="flex justify-between">
      <BackButton/>
    </div>
    <h2 class="text-center font-semibold text-lg my-2">
      400
      <span class="block text-gray-500 text-sm">Bad Request</span>
    </h2>
  </div>
</template>

<script>
import title from '@/title';
import BackButton from '@/components/BackButton.vue'

export default {
  name: 'error-bad-request',
  beforeRouteEnter: (to, from, next) => {
    document.title = title('400 Bad Request');
    next();
  },
  components: {
    BackButton,
  }
}
</script>
